module.exports = __webpack_public_path__ + "static/media/film-prod-city-page-hero.03482ebd.jpg";